import { NETWORK_TYPE_CONSTS, NetworkType } from "../types/networkType";
import { ScriptInterface } from "../types/scriptInterface";
import { WalletProviderType } from "../enum/wallet-provider-type";
import { WalletProvider } from "../model/walletProvider";
import { publicEnvConfig } from "../../config/config";
import { Dayjs } from "dayjs";
import type { DestinationCard } from "@/app/types/common";

export abstract class Helper {
  static getNetworkTypeForChainId(chainId: number): NetworkType {
    switch (chainId) {
      case 502: {
        return NETWORK_TYPE_CONSTS.columbus;
      }
      default: {
        return NETWORK_TYPE_CONSTS.local;
      }
    }
  }

  static readonly SCRIPT_STORE: Array<ScriptInterface> = [
    {
      name: "googleMaps",
      src: `https://maps.googleapis.com/maps/api/js?key=${publicEnvConfig.googleMapsKey}&v=weekly&language=en`,
    },
  ];

  static readonly WALLET_PROVIDERS: Array<WalletProvider> = [
    new WalletProvider(
      "MetaMask",
      WalletProviderType.METAMASK,
      "metamask.svg",
      false
    ),
    new WalletProvider(
      "Coinbase",
      WalletProviderType.COINBASE,
      "coinbase.png",
      false
    ),
    new WalletProvider(
      "WalletConnect",
      WalletProviderType.WALLET_CONNECT,
      "wallet-connect.png",
      false
    ),
    new WalletProvider(
      "Social Login",
      WalletProviderType.WEB3AUTH,
      "web3auth-mobile.png",
      true
    ),
  ];

  static readonly CONNECT_WALLET_DIALOG_OPTIONS = {
    width: "100dvw",
    maxWidth: "490px",
    autoFocus: false,
    height: "100dvh",
    maxHeight: "900px",
  };
}

export function randomIntFromInterval(min: number, max: number) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function shuffleArray(array: DestinationCard[]) {
  for (var i = array.length - 1; i > 0; i--) {
    // Generate random number
    var j = Math.floor(Math.random() * (i + 1));

    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }

  return array;
}

export function getDatesDiff(
  date: [start: Dayjs | null | undefined, end: Dayjs | null | undefined],
  duration: number
) {
  return date[0] ? date[0].diff(date[1], "days") >= duration : false;
}

export const redirect = (params: URLSearchParams) => {
  const sessionId = window.location.href.split("#")[1];
  if (sessionId) {
    console.info("Redirect not needed!");
    return;
  }
  const newurl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname +
    "?" +
    params;
  window.history.replaceState({ path: newurl }, "", newurl);
};

export const isWeb3AuthSignin = () => {
  const sessionId = window.location.href.split("#")[1];
  if (sessionId) {
    return true;
  } else {
    return false;
  }
};
